
import HeaderTwo from "../components/HeaderTwo/HeaderTwoSection";
import Footer from "../components/Footer/FooterSection";
import "../styles/infopage.scss"
// import { NavLink } from "react-router-dom";


const TermsAndConditions=()=>{

    return (
      <>
      <HeaderTwo></HeaderTwo>
    
    <div className="infopage content animate__animated animate__fadeIn animate__fast">
      <div className="section">
        <h1>Yayako Express – Terms and Conditions</h1>
        <div className="content_in">
          <p>
            These Terms and Conditions govern your use of Yayako Express’s website, mobile application, and services. By accessing or using any part of our services, you acknowledge and agree to be bound by these terms. Please read them carefully.
          </p>
        </div>
      </div>

      <div className="section">
        <h2>1. Acceptance of Terms</h2>
        <p>By using our services, you confirm that you have read, understood, and agreed to be bound by these Terms and Conditions. If you do not accept any part of these terms, please refrain from using Yayako Express.</p>
      </div>

      <div className="section">
        <h2>2. Use of Services</h2>
        <div className="subsection">
          <h3>Eligibility</h3>
          <p>To use our services, you must be at least 18 years old. By accessing Yayako Express, you confirm that you are legally eligible to enter into a binding contract.</p>
        </div>
        <div className="subsection">
          <h3>Account Registration</h3>
          <p>Certain features require you to create an account. You are solely responsible for keeping your account details secure and for any activity that occurs under your account.</p>
        </div>
        <div className="subsection">
          <h3>Prohibited Use</h3>
          <p>
            You agree not to use our platform for illegal activities or in ways that may harm Yayako Express or others. Prohibited actions include, but are not limited to, engaging in fraud, infringing on intellectual property rights, or disrupting our services.
          </p>
        </div>
      </div>

      <div className="section">
        <h2>3. Purchases and Payments</h2>
        <div className="subsection">
          <h3>Pricing</h3>
          <p>All prices are listed in Nigerian Naira and may change at any time without notice. We reserve the right to adjust prices, discontinue products, or correct pricing errors.</p>
        </div>
        <div className="subsection">
          <h3>Payments</h3>
          <p>By placing an order, you agree to provide valid and accurate payment information. Orders must be fully paid before shipment. We accept payments via card, bank transfer, and other supported methods.</p>
        </div>
        <div className="subsection">
          <h3>Order Acceptance</h3>
          <p>We reserve the right to cancel or refuse any order at our discretion. This may occur due to product unavailability, incorrect product details, or suspected fraudulent activity.</p>
        </div>
      </div>

      <div className="section">
        <h2>4. Shipping and Delivery</h2>
        <div className="subsection">
          <h3>Shipping</h3>
          <p>Orders will be shipped to the address provided at checkout. Shipping fees and delivery times vary based on location and selected shipping method.</p>
        </div>
        <div className="subsection">
          <h3>Delivery</h3>
          <p>Once your order is handed over to the shipping carrier, the risk of loss or damage passes to you. Yayako Express is not liable for any shipping-related delays or damages.</p>
        </div>
      </div>

      <div className="section">
        <h2>5. Returns and Refunds</h2>
        <div className="subsection">
          <h3>Return Policy</h3>
          <p>
            If you're unsatisfied with your purchase, you may return the item within 3 days of delivery, provided it is unused and in its original packaging. Please contact our support team to initiate the return process.
          </p>
        </div>
        <div className="subsection">
          <h3>Refunds</h3>
          <p>
            Once we receive and inspect the returned item, a refund will be processed within 30 days to your original payment method. Shipping fees are non-refundable unless the return is due to our error.
          </p>
        </div>
      </div>

      <div className="section">
        <h2>6. Intellectual Property</h2>
        <div className="subsection">
          <h3>Ownership</h3>
          <p>All content, trademarks, and intellectual property on our website and app belong to Yayako Express or our licensors. You may not use or reproduce any content without prior written permission.</p>
        </div>
        <div className="subsection">
          <h3>User-Generated Content</h3>
          <p>
            By submitting content such as reviews or comments, you grant Yayako Express a non-exclusive, royalty-free, perpetual license to use, modify, and display that content in connection with our services.
          </p>
        </div>
      </div>

      <div className="section">
        <h2>7. Limitation of Liability</h2>
        <div className="subsection">
          <h3>Disclaimer</h3>
          <p>Our services are provided on an “as-is” and “as-available” basis. We make no guarantees regarding uninterrupted or error-free service and disclaim all implied warranties to the extent permitted by law.</p>
        </div>
        <div className="subsection">
          <h3>Limitation</h3>
          <p>Yayako Express shall not be liable for any indirect, incidental, or consequential damages arising from your use of our services. Our total liability, if any, is limited to the amount paid by you for the product in question.</p>
        </div>
      </div>

      <div className="section">
        <h2>8. Indemnification</h2>
        <p>You agree to indemnify and hold Yayako Express, its affiliates, and personnel harmless from any claims or damages resulting from your use of the services or violation of these Terms and Conditions.</p>
      </div>

      <div className="section">
        <h2>9. Termination</h2>
        <p>We reserve the right to suspend or terminate your access to our services at any time and without prior notice if we believe you have violated these terms or acted in a manner harmful to our platform or other users.</p>
      </div>

      <div className="section">
        <h2>10. Governing Law</h2>
        <p>These Terms and Conditions are governed by and interpreted in accordance with the laws of Nigeria, regardless of any conflict of law provisions.</p>
      </div>

      <div className="section">
        <h2>11. Changes to These Terms</h2>
        <p>We may revise these Terms and Conditions periodically. Any changes will be posted on this page with an updated effective date. Continued use of our services after changes are posted constitutes your acceptance of the updated terms.</p>
      </div>

      <div className="section">
        <h2>12. Contact Us</h2>
        <p>If you have any questions or concerns regarding these Terms and Conditions, please contact our support team.</p>
        <p><strong>By using Yayako Express, you confirm your acceptance of these Terms and Conditions. Thank you for choosing Yayako Express.</strong></p>
      </div>
    </div>

    <Footer></Footer>

      </>
     )

}

export default TermsAndConditions